import { render, staticRenderFns } from "./canceled-tab.vue?vue&type=template&id=6958d10c"
import script from "./canceled-tab.vue?vue&type=script&lang=js"
export * from "./canceled-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports